import { Box, IconButton, Tooltip } from '@mui/material';
import { Replay as ReplayIcon } from '@mui/icons-material';
import React from 'react';

const UndoButton = ({ handleClick }) => (
  <Box display="flex" justifyContent="flex-end">
    <Tooltip title="Undo edit">
      <IconButton size="small" onClick={handleClick}>
        <ReplayIcon />
      </IconButton>
    </Tooltip>
  </Box>
);

export default UndoButton;
